export default "__VITE_ASSET__DRJ_VKe7__"